import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { resetPasswordSchema } from "./schemas/authenticationSchema";

import Button from "../../components/Button";
import Input from "../../components/Input";

import { resetPassword } from "./api/authRequest";

const ResetPassword = () => {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const navigate = useNavigate();

    const { search } = useLocation();
    const token = new URLSearchParams(search).get("token");

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(resetPasswordSchema),
    });

    const onSubmit = async ({ password }) => {
        setError("");

        if (!token) {
            setError("Reset token missing. Use the link from your email.");
            return;
        }

        try {
            await resetPassword({ token, password });
            setSuccess(true);
            setTimeout(() => {
                navigate("/");
            }, 2000);
        } catch (err) {
            const status = err.response?.status;
            if (status === 400 || status === 403) {
                setError(
                    "This link is invalid or expired. Please request a new one."
                );
            } else {
                setError("Couldn't reset password. Try again later.");
            }
        }
    };

    return (
        <>
            <div className="custom-container mx-auto w-4/5 lg:w-1/2">
                <div className="text-base md:text-2xl text-center mx-auto mb-6">
                    <h4 className="mb-2">Reset Password</h4>
                    <p>Please enter your new password.</p>
                </div>
                <form
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Input
                        label="New Password"
                        name="password"
                        type="password"
                        register={register}
                        errors={errors}
                        placeholder="Enter your new password"
                    />
                    <Input
                        label="Confirm New Password"
                        name="confirmPassword"
                        type="password"
                        register={register}
                        errors={errors}
                        placeholder="Confirm your new password"
                    />
                    {error && <p className="text-red-600">{error}</p>}
                    {success && !error && (
                        <p className="text-teal-600 font-semibold">
                            Password has been successfully reset! Redirecting to
                            login page...
                        </p>
                    )}
                    <Button
                        type="submit"
                        isLoading={isSubmitting}
                        disabled={isSubmitting || success}
                    >
                        Reset Password
                    </Button>
                </form>
                <Button
                    className="mt-4"
                    onClick={() => navigate("/")}
                    variant="outline"
                >
                    &lt; Back
                </Button>
            </div>
        </>
    );
};

export default ResetPassword;
